export { default as Icon } from "./Icon.js";
export * from "./Icon.types.js";
